import React from 'react'
import FJLocalStore from '../../../store/FJLocalStore'
import FJFilterCommon from "./FJFilterCommon";
import styles from './FJAdjustView.module.less'
import FJAdjustItem from "./FJAdjustItem";

function FJAdjustView(props) {
  const {adjustActive, onAdjustActiveChange, list, values, applyToAll, onAdjustChange, onReset, disableAdjusts} = props;
  return (
    <FJFilterCommon active={adjustActive}
                    hasReset
                    applyToAll={applyToAll}
                    onReset={onReset}
                    title={FJLocalStore._('adjust')}
                    onActiveChange={onAdjustActiveChange}>
      <div className={styles.list}>
        {
          list.map(item => {
              const {key, min, max, sliderColor} = item;
              return <FJAdjustItem key={key}
                                   disabled={!adjustActive || disableAdjusts.includes(key)}
                                   value={values[key]}
                                   itemKey={key}
                                   name={FJLocalStore._(key)}
                                   callback={onAdjustChange}
                                   min={min}
                                   max={max}
                                   sliderColor={sliderColor} />
            }
          )
        }
      </div>
    </FJFilterCommon>
  );
}

export default FJAdjustView;